// extracted by mini-css-extract-plugin
module.exports = {"container":"product-page_container__3NyQq"};